import React from 'react'
import { MessageTemplate } from './MessageTemplate'
import { AutoAwesome } from '@mui/icons-material'





function ConversationView({conversationList,sendInterectiveMessage}) {

  return (
        conversationList.map(conversation =>
        <>
          {conversation.type=='o' ?
            <div className='d-flex justify-content-end'>
            <div className=" my-2 p-3" style={{backgroundColor:"#ececec", borderRadius:100,  borderTopRightRadius:0}}>
              
              {conversation.dataType === "image" && <img src={conversation.msg} className='img-thumbnail' style={{maxWidth:200}} /> }

              {conversation.dataType === "location" && "You Shared Your Current Location" }
              {conversation.dataType === "audio" && 
                <div>
                  <audio controls>
                    <source src={conversation.msg} />
                  </audio>
                </div>
              }

              {conversation.dataType === "text" && <span>{conversation.msg}</span> }
              </div>
            </div>
            :
            <div className='d-flex justify-content-start'>
            <div className="ms-4 my-2">
              <div className='m-2 text-primary'>
                <AutoAwesome/>
              </div>
              <MessageTemplate message={conversation.msg.formValues} messageType={conversation.msg.messageType} callBack={sendInterectiveMessage} />
            </div>
            </div>
          }
        </>
        )
  )
}

export default ConversationView